import axios from 'axios';

export const baseUrl = process.env.REACT_APP_BASE_URL;

axios.defaults.baseURL = baseUrl;

export const authHeaders = () => {
  const accessToken = localStorage.getItem('accessToken');
  if (!!accessToken) {
    return {
      Authorization: `Bearer ${accessToken}`,
    };
  }
  return null;
};

const config = (contentType) => {
  const auth = authHeaders();
  const baseHeaders = {
    'Content-Type': contentType || 'application/json',
  };
  const config = { headers: null };
  config.headers = !!auth ? { ...baseHeaders, ...auth } : baseHeaders;
  return config
};

export const HTTP = {
  get: (url) => axios.get(url, config()),
  postJson: (url, json) => axios.post(url, json, config()),
  postFormData: (url, formData) => axios.post(url, formData, config('application/x-www-form-urlencoded')),
  postMultipartFormData: (url, formData) => axios.post(url, formData, config('multipart/formdata')),
  putJson: (url, json) => axios.put(url, json, config()),
  putFormData: (url, formData) => axios.put(url, formData, config('application/x-www-form-urlencoded')),
};
